import React, { useState, Fragment } from 'react';
import { withWizard } from 'react-albus';
import { Query } from 'react-apollo';
import { Box, Button, Flex, Heading, Text } from 'rebass';
import styled, { keyframes } from 'styled-components';
import PleaseWait from '../../components/PleaseWait';
import { Input, InputWithLabel } from '../../components/TextInput';
import { GET_GENDER_IDENTITIES } from '../../graphql';
import theme from '../../styles/theme';
import { OPTIONS_ANIMATION_DURATION } from '../weightLossPrequalification/components/constants';
import { isMobile } from 'react-device-detect';

const Btn = styled(Button)`
  background: #ffffff;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
  border-radius: 10px;
  border: 1px solid #ffffff;
  font-size: 14px;
  font-weight: 300;

  transition: background 300ms ease-in;
  &.selected {
    background: #e7f0ff;
    border: 1px solid #354e79;
    box-sizing: border-box;
  }
`;
const SelectedMarkerOut = styled(Flex)`
  width: 24px;
  height: 24px;
  justify-content: center;
  align-items: center;

  background: #ffffff;
  border: 2px solid #354e79;
  border-radius: 12px;
  margin-right: 12px;
`;
const SelectedMarkerIn = styled(Flex)`
  width: 16px;
  height: 16px;
  border-radius: 8px;
  background: #354e79;
  transition: all 450ms ease-in;
`;
const slideLeft = keyframes`
  0% {
    opacity: 0;
    transform: translateY(15px);
  };
  100% {
    opacity: 1;
    transform: translateY(0px);
  };
`;

const Option = styled(Flex)`
  opacity: 0;
  animation: 400ms cubic-bezier(0.64, 0, 0.28, 1) 0s 1 normal forwards running ${slideLeft};
`;
const FootNote = styled(Flex)`
  opacity: 0;
  animation-delay: 1.24s;
  animation-direction: normal;
  animation-duration: 0.4s;
  animation-fill-mode: forwards;
  animation-iteration-count: 1;
  animation-name: ${slideLeft};
  animation-play-state: running;
  animation-timing-function: cubic-bezier(0.64, 0, 0.28, 1);
  box-sizing: border-box;
  flex: 1;
  flex-direction: column;
  justify-content: flex-end;
`;

const Rect = styled.rect`
  transition: all var(0.3s) linear;
`;
const CheckboxWrap = styled(Flex)`
  border-color: rgba(0, 0, 0, 0.19);
  border-width: 2px;
  border-radius: 50%;
  border-style: solid;
  transition: all var(0.3s) linear;
  overflow: hidden;
  height: 20px;
  width: 20px;
`;

const GenderIdentity = ({ state, id, onChange, onContinue, onChangeMultiple }) => {
  return (
    <Query query={GET_GENDER_IDENTITIES}>
      {({ loading, data }) => {
        if (!!loading) {
          return <PleaseWait />;
        }

        return (
          <Flex flex={1} flexDirection="column">
            <Text style={{ fontSize: isMobile ? '26px' : '32px', fontWeight: 500 }} mb={4}>
              What is your gender identity?
            </Text>
            <Flex my={3} flexDirection={'column'} flex={1}>
              {data.getGenderIdentities &&
                data.getGenderIdentities.map((x, i) => {
                  const isSelected = state['genderidentity'] === x;
                  return (
                    <Option
                      key={x}
                      style={{
                        animationDelay: `${1 + i * OPTIONS_ANIMATION_DURATION}s`,
                      }}
                    >
                      <Flex flexDirection={'column'} flex={1}>
                        <Flex
                          mb={3}
                          style={{
                            cursor: 'pointer',
                            overflow: 'hidden',
                            width: '100%',
                            borderRadius: '12px',
                            border: `${isSelected ? '2px solid rgb(249, 163, 148)' : '1px solid rgba(0, 0, 0, 0.15)'}`,
                            padding: isMobile ? (isSelected ? '14px 18px' : '15px 19px') : isSelected ? '18px' : '19px',
                            backgroundColor: isSelected ? 'rgba(255,255,255,0.43)' : 'transparent',
                            flex: 1,
                          }}
                          onClick={() => {
                            onChangeMultiple([{ id: 'otherGenderIdentity', value: null }, { id: 'genderidentity', value: x }]);
                          }}
                        >
                          <CheckboxWrap style={{ borderColor: isSelected ? theme.color.pink : '', alignSelf: 'baseline' }}>
                            <Flex
                              flex={1}
                              style={{ background: isSelected ? theme.color.pink : 'transparent', borderRadius: '50%', border: isSelected ? '2px solid #fdf5f2' : 'transparent', overflow: 'hidden' }}
                            />
                          </CheckboxWrap>
                          <Flex flexDirection={'column'} ml={3} flex={1}>
                            <Text fontWeight={500} fontSize={isMobile ? '14px' : ''}>
                              {x}
                            </Text>

                            {x.indexOf('other') > -1 &&
                              isSelected && (
                                <Flex
                                  flexDirection={'row'}
                                  mt={12}
                                  flex={1}
                                  style={{ border: `1px solid #344f79`, borderRadius: '12px', padding: '12px 0px 0px 0px', background: 'white', cursor: 'pointer', alignItems: 'center' }}
                                >
                                  <Flex flex={1} flexDirection={'column'}>
                                    {/* <Text mb={0} style={{ opacity: 0.7 }} fontSize={'13px'} fontWeight={500}>
                      Pounds (lbs)
                    </Text> */}
                                    <InputWithLabel
                                      placeholder={`tell us your identiy`}
                                      style={{ border: 0, background: 'white', color: '#344f79', fontSize: isMobile ? '14px' : '' }}
                                      value={state['otherGenderIdentity']}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                      }}
                                      onChange={(e) => {
                                        onChange('otherGenderIdentity', e.target.value.toString());
                                      }}
                                    />
                                    {!state['otherGenderIdentity'] ? (
                                      <Flex ml={'12px'} mb={'12px'} alignItems={'center'}>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path
                                            d="M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20ZM12 7C12.2652 7 12.5196 7.10536 12.7071 7.29289C12.8946 7.48043 13 7.73478 13 8V13C13 13.2652 12.8946 13.5196 12.7071 13.7071C12.5196 13.8946 12.2652 14 12 14C11.7348 14 11.4804 13.8946 11.2929 13.7071C11.1054 13.5196 11 13.2652 11 13V8C11 7.73478 11.1054 7.48043 11.2929 7.29289C11.4804 7.10536 11.7348 7 12 7ZM12 17C11.7348 17 11.4804 16.8946 11.2929 16.7071C11.1054 16.5196 11 16.2652 11 16C11 15.7348 11.1054 15.4804 11.2929 15.2929C11.4804 15.1054 11.7348 15 12 15C12.2652 15 12.5196 15.1054 12.7071 15.2929C12.8946 15.4804 13 15.7348 13 16C13 16.2652 12.8946 16.5196 12.7071 16.7071C12.5196 16.8946 12.2652 17 12 17Z"
                                            fill="#BD4244"
                                          />
                                        </svg>

                                        <Text fontSize={'12px'} style={{ color: '#BD4244' }}>
                                          This information is required
                                        </Text>
                                      </Flex>
                                    ) : (
                                      <></>
                                    )}
                                  </Flex>
                                </Flex>
                              )}
                          </Flex>
                        </Flex>
                      </Flex>
                    </Option>
                    // <Box key={el} width={['100%', '50%', '50%']} style={{ display: 'flex' }}>
                    //   <Btn
                    //     disabled={loading}
                    //     type="button"
                    //     variant={'white'}
                    //     style={{ flex: 1 }}
                    //     // width={[1]}
                    //     m={3}
                    //     onClick={() => {
                    //       if (el !== selected) {
                    //         onChangeMultiple([{id:'otherGenderIdentity',value: null, },{id:'genderidentity', el}]);
                    //       }
                    //     }}
                    //     className={selected === el ? 'selected' : 'white'}
                    //   >
                    //     <Flex flex={1} flexDirection="row">
                    //       <SelectedMarkerOut>{selected === el && <SelectedMarkerIn />}</SelectedMarkerOut>
                    //       <Flex flex={1} flexDirection="column" style={{ textAlign: 'left' }}>
                    //         <Text textAlign="left" mt="4px">
                    //           {el}
                    //         </Text>
                    //         {(el || '').indexOf('specify') > -1 && selected === el ? (
                    //           <Input style={{ marginTop: '24px' }} flex={1} placeholder={'Specify'} type={'text'} value={otherSpecify} onChange={(e) => setOtherSpecify(e.target.value)} />
                    //         ) : null}
                    //       </Flex>
                    //     </Flex>
                    //   </Btn>
                    // </Box>
                  );
                })}
            </Flex>

            <FootNote
              mb={4}
              alignItems={'center'}
              style={{
                animationDelay: `${1 + 7 * OPTIONS_ANIMATION_DURATION}s`,
              }}
            >
              {/* <Flex justifyContent="center"> */}
              <Button
                mt={3}
                disabled={!state['genderidentity'] || (state['genderidentity'].indexOf('other') > -1 && !state['otherGenderIdentity'])}
                variant="primary"
                width={[1 / 2, 1 / 3]}
                onClick={() => {
                  onContinue();
                }}
              >
                Continue
              </Button>
              {/* </Flex> */}

              {/* <Flex justifyContent="center" mt={3} mb={4}> */}
              <Text
                textAlign="center"
                mt={3}
                mb={4}
                style={{ color: '#0075FF', textDecoration: 'underline' }}
                width={[1 / 2, 1 / 3]}
                onClick={() => {
                  onChangeMultiple([{ id: 'otherGenderIdentity', value: null }, { id: 'genderidentity', value: null }]);
                  onContinue();
                }}
              >
                Skip
              </Text>
              {/* </Flex> */}
            </FootNote>
          </Flex>
        );
      }}
    </Query>
  );
};

export default withWizard(GenderIdentity);
